import * as React from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputBase from '@material-ui/core/InputBase';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import classNames from 'classnames';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';

import { countries } from 'config/countries';
import { calculateUrlWithNewLocale, fallbackLocale } from 'core/i18n/locale';

import { IProps } from './interfaces';

import styles from './LanguageSwitcher.module.styl';

const mappedCountries = countries.reduce((acc: any, item: any) => {
  acc[item.value] = item.nationalName;
  return acc;
}, {});

class LanguageSwitcher extends React.Component<
  IProps & RouteComponentProps<{ locale: string }>
> {
  public render() {
    const { languages: languagesString, match } = this.props;

    const {
      params: { locale: currentLocale },
    } = match;

    const localePrefix = currentLocale || fallbackLocale;

    const languages = languagesString.split(',');

    if (languages.length > 3) {
      return (
        <FormControl>
          <Select
            name="language"
            value={localePrefix}
            onChange={this.handleChange}
            input={<InputBase className={styles.test} name="language" />}
          >
            {languages.map((option: any) => (
              <MenuItem key={option} value={option}>
                <div className={styles.root}>
                  <span
                    title={option}
                    className={styles[option] || styles.noLocale}
                  >
                    <span>{option}</span>
                  </span>
                  <span className={styles.option}>
                    {mappedCountries[option]}
                  </span>
                </div>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      );
    }

    return (
      <div className={styles.root}>
        {languages.map((locale: string) => (
          <Link
            key={locale}
            to={calculateUrlWithNewLocale(this.props, locale)}
            title={locale}
            className={classNames(
              styles.flag,
              styles[locale] || styles.noLocale,
              { [styles.active]: locale === localePrefix },
            )}
          >
            <span>{locale}</span>
          </Link>
        ))}
      </div>
    );
  }

  private readonly handleChange = (event: any) => {
    this.props.history.push(
      calculateUrlWithNewLocale(this.props, event.target.value),
    );
  };
}

export default withRouter(LanguageSwitcher);
